// extracted by mini-css-extract-plugin
export default {"ellipsisButton":"EllipsisButton_ellipsisButton__w5AFv"};